import { render, staticRenderFns } from "./EmployeeLeaveRight.vue?vue&type=template&id=ed62836e&scoped=true"
import script from "./EmployeeLeaveRight.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveRight.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveRight.vue?vue&type=style&index=0&id=ed62836e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed62836e",
  null
  
)

export default component.exports